// extracted by mini-css-extract-plugin
export var address = "footer-module--address--e2a32";
export var addressContainer = "footer-module--addressContainer--8e174";
export var contactContainer = "footer-module--contactContainer--ca786";
export var contactTitle = "footer-module--contactTitle--78cce";
export var copyright = "footer-module--copyright--b80ae";
export var copyrightContainer = "footer-module--copyrightContainer--96e59";
export var footerContainer = "footer-module--footerContainer--5a73b";
export var link = "footer-module--link--9ad08";
export var linkBlocContainer = "footer-module--linkBlocContainer--9ba21";
export var linkBlocContent = "footer-module--linkBlocContent--cc994";
export var linkBlocTitle = "footer-module--linkBlocTitle--30d73";
export var linkContainer = "footer-module--linkContainer--8cbc8";
export var linkItem = "footer-module--linkItem--52ff3";
export var logoContainer = "footer-module--logoContainer--f4226";
export var logoImg = "footer-module--logoImg--1dbd8";
export var mainContainer = "footer-module--mainContainer--c38ce";
export var mediaContainer = "footer-module--mediaContainer--a9eb3";
export var miscellaneousContainer = "footer-module--miscellaneousContainer--0d437";
export var newsletterButtonContainer = "footer-module--newsletterButtonContainer--c81f4";
export var newsletterButtonTitle = "footer-module--newsletterButtonTitle--c4722";
export var newsletterContainer = "footer-module--newsletterContainer--2b78d";
export var newsletterTitle = "footer-module--newsletterTitle--82c1b";
export var phone = "footer-module--phone--d3482";
export var smartNewsletterButtonTitle = "footer-module--smartNewsletterButtonTitle--4af06";
export var socialMediaAnchor = "footer-module--socialMediaAnchor--1bf25";
export var socialMediaContainer = "footer-module--socialMediaContainer--bd3f4";
export var socialMediaIconContainer = "footer-module--socialMediaIconContainer--c7687";
export var socialMediaItem = "footer-module--socialMediaItem--f9089";
export var socialMediaList = "footer-module--socialMediaList--f643c";
export var socialMediaTitle = "footer-module--socialMediaTitle--4526a";